"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelText = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("../../textinput/styled/formInputTheme");
var _checkboxTheme = require("../checkboxTheme");
const getLabelColor = _ref => {
  let {
    isDisabled,
    themeMode
  } = _ref;
  return isDisabled ? _checkboxTheme.checkboxLabelTheme.color.disabled(themeMode) : _checkboxTheme.checkboxLabelTheme.color.rest(themeMode);
};
const LabelText = (0, _styled.default)("span")`
    // We want the first line of text to line up with the checkbox so we cannot use flex to center.
    // In a multi-line label, the checkbox would be centered in the middle line of text, rather than
    // the first.
    margin-top: 1px;
    margin-left: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _checkboxTheme.checkboxLabelTheme.gap(themeMode);
}};
    color: ${getLabelColor};
    font-weight: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _checkboxTheme.checkboxLabelTheme.fontWeight(themeMode);
}};
    font-size: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _formInputTheme.formInputTheme.fontSize.box(themeMode);
}};
`;
exports.LabelText = LabelText;
//# sourceMappingURL=LabelText.js.map